"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scale = void 0;
const styled_components_1 = require("styled-components");
const foundation_1 = require("../foundation");
exports.scale = {
    ids_scale_general_up: (0, styled_components_1.css) `
    @keyframes ids_scale_general_up {
      from {
        transform: scale(${foundation_1.foundation_scale.small.scale_small_none});
      }

      to {
        transform: scale(${foundation_1.foundation_scale.large.scale_large_100});
      }
    }
  `,
    ids_scale_general_down: (0, styled_components_1.css) `
    @keyframes ids_scale_general_down {
      from {
        transform: scale(${foundation_1.foundation_scale.large.scale_large_100});
      }

      to {
        transform: scale(${foundation_1.foundation_scale.small.scale_small_none});
      }
    }
  `,
    ids_scale_dividerInput_in: (0, styled_components_1.css) `
    @keyframes ids_scale_general_in {
      from {
        transform: scale(${foundation_1.foundation_scale.large.scale_large_80});
      }

      to {
        transform: scale(${foundation_1.foundation_scale.large.scale_large_100});
      }
    }
  `,
};
//# sourceMappingURL=scale.js.map